// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__2njrJ","icon":"CloseButton_icon__Avww3"};